import React, { useState, useEffect, useRef } from 'react';
import { Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, View, FlatList, ScrollView, useWindowDimensions, Keyboard } from 'react-native';
import * as Animatable from 'react-native-animatable';
import Colors from '../assets/Colors';
import Info from './info/Info';
import Home from './home/Home';
import Search from './search/Search';
import { FiSearch, FiHome } from 'react-icons/fi';
import { FaRegNewspaper } from "react-icons/fa";

const params = {};

const TabArr = [
  { route: 'Info', label: 'Info', icon: FaRegNewspaper, component: Info, params: params, color: Colors.primary, alphaClr: Colors.primaryAlpha },
  { route: 'Home', label: 'Home', icon: FiHome, component: Home, params: params, color: Colors.primary, alphaClr: Colors.primaryAlpha },
  { route: 'Search', label: 'Ricerca', icon: FiSearch, component: Search, params: params, color: Colors.primary, alphaClr: Colors.primaryAlpha }
];

var marginBottomBtn = 10;
if (Platform.OS === 'ios') {
  const { width, height } = useWindowDimensions();
  const isTablet = width >= 768;
  const isIphone = width < 768 && height < 812;
  /*
  if (isTablet) {
    marginBottomBtn = 15;
  } else if (isIphone) {
    marginBottomBtn = 25;
  }
  */
}

const Screen = ({ item }) => {
  const { width, height: fullHeight } = useWindowDimensions();
  const [height, setHeight] = useState(fullHeight - (80 + marginBottomBtn));
  /*
  useEffect(() => {
    const updateHeight = () => {
      setHeight(fullHeight - (80 + marginBottomBtn));
    };

    const showSubscription = Keyboard.addListener('keyboardDidShow', () => {
      setHeight(fullHeight);
    });
    const hideSubscription = Keyboard.addListener('keyboardDidHide', updateHeight);

    updateHeight();

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, [width, fullHeight]);
  */
  const screenStyle = {
    flex: 1,
    paddingHorizontal: 14,
    paddingTop: 10,
    height: height,
    width: width,
  }

  return (
    <View style={screenStyle}>
      <item.component params={item.params} />
    </View>
  );
}

const TabButton = ({ item, onPress, focused }) => {
  const viewRef = useRef(null);
  const textViewRef = useRef(null);

  useEffect(() => {
    if (focused) {
      viewRef.current.animate({ 0: { scale: 0 }, 1: { scale: 1 } });
      textViewRef.current.animate({ 0: { scale: 0 }, 1: { scale: 1 } });
    } else {
      viewRef.current.animate({ 0: { scale: 1, }, 1: { scale: 0, } });
      textViewRef.current.animate({ 0: { scale: 1 }, 1: { scale: 0 } });
    }
  }, [focused])

  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={1}
      style={[styles.container, { flex: focused ? 1 : 0.65 }]}>
      <View>
        <Animatable.View
          ref={viewRef}
          style={[StyleSheet.absoluteFillObject, { backgroundColor: item.color, borderRadius: 16 }]} />
        <View style={[styles.btn, { backgroundColor: focused ? null : item.alphaClr }]}>
          <item.icon color={focused ? Colors.white : item.color} size={24} />
          <Animatable.View
            ref={textViewRef}>
            {focused &&
              <Text style={{ color: Colors.white, paddingHorizontal: 8 }}>
                {item.label}
              </Text>
            }
          </Animatable.View>
        </View>
      </View>
    </TouchableOpacity>
  );
};



/*
export default function Main() {
  const [currentIndex, setCurrentIndex] = useState(1);
  //const viewConfig = useRef({ viewAreaCoveragePercentThreshold: 40 }).current;
  const scrollViewRef = useRef(null);
  const { width } = useWindowDimensions();

  const calculateCurrentIndex = (event) => {
    const contentOffset = event.nativeEvent.contentOffset.x;
    if (contentOffset > (currentIndex + 0.66) * width) {
      setCurrentIndex(currentIndex + 1);
    } else if (contentOffset < (currentIndex - 0.66) * width) {
      setCurrentIndex(currentIndex - 1);
    }
  };


  const scrollToScreen = (screenIndex) => {
    const index = TabArr.findIndex((item) => item.route === screenIndex);
    if (index !== -1) {
      const offset = index * width;
      if (scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ x: offset, animated: true });
      }
    }
  };


  useEffect(() => {
    const offset = currentIndex * width;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ x: offset, animated: false });
    }
  }, [width]);

  useEffect(() => {
    const offset = currentIndex * width;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ x: offset, animated: false });
    }
  }, []);

  // set params: variable for all screens
  const [homeGenere, setHomeGenere] = useState('');
  params['homeGenere'] = homeGenere;
  params['setHomeGenere'] = setHomeGenere;
  params['scrollToScreen'] = scrollToScreen;
  params['currentIndex'] = currentIndex;

  window.appData.contatti.forEach((c) => {
    if (c.iconName === "email") {
      params['contattoEmail'] = c.value;
    }
    if (c.iconName === "phone") {
      params['contattoTelefono'] = c.value.replaceAll("+", "").replaceAll(" ", "");
    }
  });


  return (
    <SafeAreaView style={styles.app}>
      <ScrollView
        horizontal
        keyboardDismissMode="on-drag"
        ref={scrollViewRef}
        showsHorizontalScrollIndicator={false}
        pagingEnabled
        bounces={false}
        scrollEventThrottle={16}
        //onScroll={calculateCurrentIndex}
        onScrollEndDrag={calculateCurrentIndex}
        decelerationRate={0}
        snapToInterval={width}
        snapToAlignment="center"
        contentContainerStyle={{ flexDirection: 'row' }}
      >
        {TabArr.map((item, index) => (
          <Screen key={item.route} item={item} />
        ))}
      </ScrollView>
      <View style={styles.btnContainer}>
        {
          TabArr.map((item, index) => (
            <TabButton
              key={index}
              item={item}
              onPress={() => scrollToScreen(item.route)}
              focused={currentIndex === index}
            />
          ))}
      </View>
    </SafeAreaView>
  );
}
*/



export default function Main() {
  const [currentIndex, setCurrentIndex] = useState(0);
  //const viewConfig = useRef({ viewAreaCoveragePercentThreshold: 40 }).current;
  const flatListRef = useRef(null);
  const [canScroll, setCanScroll] = useState(false);
  const { width } = useWindowDimensions();

  const calculateCurrentIndex = (event) => {
    const contentOffset = event.nativeEvent.contentOffset.x;
    if (contentOffset > (currentIndex + 0.66) * width) {
      setCurrentIndex(currentIndex + 1);
    } else if (contentOffset < (currentIndex - 0.66) * width) {
      setCurrentIndex(currentIndex - 1);
    }
  };


  //  const calculateCurrentIndex = (event) => {
  //    if (canScroll) {
  //      const contentOffset = event.nativeEvent.contentOffset.x;
  //      let nextIndex = currentIndex;
  //      if (contentOffset > (currentIndex + 0.66) * width) {
  //        nextIndex = currentIndex + 1; // Move to the next index
  //      } else if (contentOffset < (currentIndex - 0.66) * width) {
  //        nextIndex = currentIndex - 1; // Move to the previous index
  //      }
  //
  //      if (nextIndex !== currentIndex) {
  //        setCurrentIndex(nextIndex);
  //      }
  //    } else if (flatListRef.current) {
  //      console.log('Scrolling without dragging');
  //      //TODO: fix this, i want to prevent the scroll from 0 to 2 
  //    }
  //  };


  const scrollToScreen = (screenIndex) => {
    var index = TabArr.findIndex(item => item.route === screenIndex);
    if (index !== -1) {
      const offset = index * width;
      flatListRef.current.scrollToOffset({ offset, animated: true });
    }
  };

  useEffect(() => {
    if (flatListRef.current) {
      flatListRef.current.scrollToIndex({ index: currentIndex, animated: false });
    }
  }, [width]);

  // set params: variable for all screens
  const [homeGenere, setHomeGenere] = useState('');
  params['homeGenere'] = homeGenere;
  params['setHomeGenere'] = setHomeGenere;
  params['scrollToScreen'] = scrollToScreen;
  params['currentIndex'] = currentIndex;

  window.appData.contatti.forEach((c) => {
    if (c.iconName === "email") {
      params['contattoEmail'] = c.value;
    }
    if (c.iconName === "phone") {
      params['contattoTelefono'] = c.value.replaceAll("+", "").replaceAll(" ", "");
    }
  });


  return (
    <SafeAreaView style={styles.app}>
      <FlatList
        data={TabArr}
        renderItem={({ item }) => <Screen item={item} />}
        horizontal
        showsHorizontalScrollIndicator={false}
        pagingEnabled
        bounces={false}
        keyExtractor={(item) => item.route}
        onScroll={calculateCurrentIndex}
        scrollEventThrottle={16}
        ref={flatListRef}
        initialScrollIndex={1}
        getItemLayout={(data, index) => ({ length: width, offset: width * index, index })}
        onTouchStart={() => setCanScroll(true)}
        onTouchEnd={() => setCanScroll(false)}
        decelerationRate="fast"
        snapToInterval={width}
        snapToAlignment="center"
      />
      <View style={styles.btnContainer}>
        {
          TabArr.map((item, index) => (
            <TabButton
              key={index}
              item={item}
              onPress={() => scrollToScreen(item.route)}
              focused={currentIndex === index}
            />
          ))}
      </View>
    </SafeAreaView>
  );
}



const styles = StyleSheet.create({
  app: {
    flex: 1,
    backgroundColor: Colors.primaryAlpha,
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 60,
  },
  btnContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: 70,
    borderRadius: 35,
    borderWidth: 1,
    borderColor: '#ccc',
    marginHorizontal: 10,
    marginBottom: marginBottomBtn,
    backgroundColor: 'white',
  },
  btn: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    borderRadius: 16,
  }
});
